module.exports = __webpack_public_path__ + "img/le-quartier.2358901a.svg";